import { useEffect } from 'react'
import { hasBackorderedItems } from '../utils/rti'

/**
 * Sets a session storage to notify the checkout page to show or not show a notification banner to the customer
 * @param {object} cart
 */
const useRTISessionStorage = (cart) => {
  const hasBackorderItems = hasBackorderedItems(cart)
  const cartId = cart.root?.id

  useEffect(() => {
    // setting to false so the checkout knows to render a notification banner
    if (!hasBackorderItems) {
      sessionStorage.setItem(`dc.ui.${cartId}.backOrderNotification`, false)
    }
    // setting to true so the checkout knows to not render a notification as the customer has been notified on cart page
    if (hasBackorderItems) {
      sessionStorage.setItem(`dc.ui.${cartId}.backOrderNotification`, true)
    }
  }, [cart])
}

export default useRTISessionStorage
